import { useSetRecoilState } from 'recoil';
import {
    teams,
    draftTeams,
    reposToMigrate,
    fetchedAdoRepos,
    argoCDConfigData,
    validOnboardingForm,
    isUserAccessConfigFullFilled,
    isAssignReposConfigFullFilled,
    isMigrateRepoConfigFullFilled,
    isMicroServiceConfigFullFilled,
    teamValidationCache,
    sonarQubeConfig,
    jfrogConfig,
    isSonarQubeConfigFilled,
    isJfrogConfigFilled,
    pipelineClassificationData,
    newOnboardingPipelineConfig,
    newOnboardingPipelineTemplates,
    newOnboardingPipelineEligible,
} from 'pages/provisioning/day2/github-onboarding-new/store';
import { COMMON } from 'pages/provisioning/day2/github-onboarding-new/utils/constant';

const useResetConfigurations = () => {
    const setTeams = useSetRecoilState(teams);
    const setDraftTeams = useSetRecoilState(draftTeams);
    const setReposToMigrate = useSetRecoilState(reposToMigrate);
    const setFetchedGithubRepos = useSetRecoilState(fetchedAdoRepos);
    const setFetchedAdoRepos = useSetRecoilState(fetchedAdoRepos);
    const setArgoCDConfigData = useSetRecoilState(argoCDConfigData);
    const setValidFrom = useSetRecoilState(validOnboardingForm);
    const setIsUserAccessConfigFilled = useSetRecoilState(isUserAccessConfigFullFilled);
    const setIsAssignReposConfigFilled = useSetRecoilState(isAssignReposConfigFullFilled);
    const setIsMigrateRepoConfigFilled = useSetRecoilState(isMigrateRepoConfigFullFilled);
    const setIsMicroServiceConfigFilled = useSetRecoilState(isMicroServiceConfigFullFilled);
    const setTeamValidationCache = useSetRecoilState(teamValidationCache);
    const setSonarQubeConfig = useSetRecoilState(sonarQubeConfig);
    const setJfrogConfig = useSetRecoilState(jfrogConfig);
    const setIsSonarQubeConfigFilled = useSetRecoilState(isSonarQubeConfigFilled);
    const setIsJfrogConfigFilled = useSetRecoilState(isJfrogConfigFilled);
    const setPipelineClassificationData = useSetRecoilState(pipelineClassificationData);
    const setNewOnboardingPipelineConfig = useSetRecoilState(newOnboardingPipelineConfig);
    const setNewOnboardingPipelineTemplates = useSetRecoilState(newOnboardingPipelineTemplates);
    const setNewOnboardingPipelineEligible = useSetRecoilState(newOnboardingPipelineEligible);

    const resetConfigurations = () => {
        const resetTeamData = (teamList) =>
            teamList
                ?.filter((team) => !team.isNew)
                .map((team) => ({
                    ...team,
                    members: [],
                    originalMembers: [],
                    removedMembers: [],
                    repos: [],
                    originalRepos: [],
                    existingOrgMembers: [],
                    hasExistingMembers: false,
                    teamExistsInOrg: false,
                }));

        setTeams((prev) => resetTeamData(prev));
        setDraftTeams((prev) => resetTeamData(prev));
        setReposToMigrate([]);
        setFetchedGithubRepos([]);
        setFetchedAdoRepos([]);
        setArgoCDConfigData([]);
        setValidFrom({
            isDuplicateGithubADGroupMember: false,
            isGithubADGroupTrainingValid: false,
            isDuplicateGitHubAdMember: false,
            isMemberMissingEmail: false,
            isInvalidDomain: false,
            isNotValidGithubRepositoryName: false,
            isDuplicateRepositoryName: false,
            isDuplicateTeamMember: false,
            adGroupMemberMatchedBaseGroups: [],
            adGroupMemberMatchedCoPilotGroups: [],
            adGroupMemberApiMessage: '',
            isAdGroupMemberNotEligible: false,
            isAdGroupMemberEligibleWithCoPilot: false,
        });

        setIsUserAccessConfigFilled(false);
        setIsAssignReposConfigFilled(false);
        setIsMigrateRepoConfigFilled(false);
        setIsMicroServiceConfigFilled(false);

        setTeamValidationCache({});

        setSonarQubeConfig({
            requiresIntegration: null,
            validationData: null,
            serviceAccountsFromApi: [],
            shouldValidate: true,
            shouldModifyProjectName: COMMON.NO,
            modifiedSonarProjects: [],
            isSonarGroupServiceAccount: false,
            sonarGroupServiceAccount: null,
            sonarGroupServiceAccountValid: false,
            isServiceAccountExists: null,
            hasServiceAccount: null,
            serviceAccount: '',
            serviceAccountValidationError: null,
        });

        setJfrogConfig({
            requiresIntegration: null,
            dependencyRepoOption: null,
            hasArtifactoryName: null,
            projectOrganization: null,
            repoConfigurations: [],
            jfrogRepoTypes: [],
        });

        setIsSonarQubeConfigFilled(false);
        setIsJfrogConfigFilled(false);
        setPipelineClassificationData([]);
        setNewOnboardingPipelineConfig([]);
        setNewOnboardingPipelineTemplates([]);
        setNewOnboardingPipelineEligible(null);
    };

    return { resetConfigurations };
};

export default useResetConfigurations;
